import { SplitDaysToPolicy } from "constants/common/SplitDaysToPolicy";
import _ from "lodash";

export const SplitDaysToDroOpts = () => {

    const getDroOptsModel = () => {
        let ret: string[] = [SplitDaysToPolicy.ITEM_SHIP_CONS_FOR, SplitDaysToPolicy.ITEM_OWNER];
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];
    }

    return {
        getDroOptsModel
    }
}